import styled from 'styled-components';

import { TableContainer as DefaultTable } from 'components/DefaultTable/styles';

export const TableActions = styled.div`
  margin-bottom: 32px;
`;

export const Table = styled(DefaultTable)`
  tbody tr:hover {
    cursor: default;
    background-color: transparent;
  }

  thead tr th {
    svg {
      margin-left: 8px;
    }

    &:nth-child(5),
    &:last-child {
      text-align: center;
    }
  }

  ${({ isAdmin }) =>
    isAdmin
      ? `
    thead tr th {
      &:nth-child(2), &:last-child {
        cursor: pointer;
      }
    }

    tbody tr td {
      &:nth-child(3) {
        width: 20vw;
      }
    }
  `
      : `
    thead tr th {
      &:first-child, &:last-child {
        cursor: pointer;
      }
    }

    &:nth-child(2) {
      width: 20vw;
    }
  `}

  tbody tr td {
    &:nth-child(5),
    &:last-child {
      text-align: center;
    }
  }
`;
